/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { GraphQLList as List } from 'graphql';
import fetch from '../../core/fetch';
import PageServiceType from '../types/PageServiceType';

const url = 'http://agenceprolifik.ca/dev/wp-json/wp/v2/pages/361/';

let item;

const developpementWeb = {
    type: PageServiceType,
    resolve() {
        
        return fetch(url)
        .then(res => {
            
            return res.json();
           
        })
        .then(data => {
           
            item = data;
            return item;

        });
    },
};

export default developpementWeb;



// WEBPACK FOOTER //
// ./data/queries/developpementWeb.js